enum LoggedInUserType {
  PLATFORM = "PLATFORM",
  EVENT_SERIES = "EVENT_SERIES",
  MY_EXP = "MY_EXP"
}

export default LoggedInUserType;
